module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper dashboard-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('a', {
    attrs: {
      "href": "#/accidentInformationPage"
    }
  }, [_c('div', {
    staticClass: "box  palette-Dark bg"
  }, [_c('div', {
    staticClass: "box-header  palette-Dark bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("directions_car")])]), _vm._v("   \n                ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   REPORT AN ACCIDENT")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('h2', {
    staticClass: "text-white"
  }, [_c('strong', [_c('span', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("File your Auto-Accident Claim Here")])])]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Report your auto-accident to get started with getting your claim.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap-no-pad text-white accident-post-nest"
  }), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('h6', {
    staticStyle: {
      "color": "white"
    }
  }, [_c('strong', [_c('b', [_vm._v("Click/Tap Here to Get started.")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('a', {
    attrs: {
      "href": "#/updatePlaceholder"
    }
  }, [_c('div', {
    staticClass: "box  palette-Dark bg"
  }, [_c('div', {
    staticClass: "box-header  palette-Dark bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("assignment_turned_in")])]), _vm._v("   \n                ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   CLAIM STATUS")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white"
    }
  }, [_c('strong', [_c('span', [_vm._v("Auto-Accident Claim Status")])])]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Check the progress of your Auto-Accident here.")]), _vm._v(" "), _c('div', {
    staticClass: "wrap-no-pad text-white status-post-nest"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h6', {
    staticStyle: {
      "color": "white"
    }
  }, [_c('strong', [_c('b', [_vm._v("Click/Tap Here to Get started.")])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('a', {
    attrs: {
      "href": "#/updatePlaceholder"
    }
  }, [_c('div', {
    staticClass: "box  palette-Dark bg"
  }, [_c('div', {
    staticClass: "box-header palette-Indigo-900 palette-Dark bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("card_giftcard")])]), _vm._v("   \n                ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   OFFERS/REWARDS")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticStyle: {
      "color": "white"
    }
  }, [_c('h2', {
    staticClass: "text-white"
  }, [_c('strong', [_c('span', [_vm._v("Check Your Rewards")])])]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("Check here for new offers and rewards!")])]), _vm._v(" "), _c('div', {
    staticClass: "wrap-no-pad text-white offers-post-nest"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('h6', {
    staticStyle: {
      "color": "white"
    }
  }, [_c('strong', [_c('b', [_vm._v("Click/Tap Here to Get started.")])])])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7551b81e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/Index.vue
// module id = 1310
// module chunks = 2